<script lang="ts" setup>
import { useAssessmentTestStore } from '@stores/assessment-test'

defineOptions({
  name: 'AssessmentCounter',
})

const assessmentTestStore = useAssessmentTestStore()

</script>

<template>
  <div class="assessment-counter">
    <div class="assessment-counter__body-l btly-text-body-l">
      {{ assessmentTestStore.getCurrentQuestionIndex + 1 }} / {{ assessmentTestStore.getQuestionsTotal }}
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Assessment/AssessmentCounter.scss" />
